import { PageRef } from 'providers/page-ref';
import { FitnessPlan } from '@cf-shared/data-model/fitness-plan';
import { FitnessState } from '@cf-shared/data-model/user-state';

export type ExerciseSwitchPageParams = {
  workoutId: string; // letter of the workout that this will be used in
  isNewWorkout?: boolean; // whether adding a new exercise because creating a new workout
  subSlotId: string; // subslot id that this will be used in, undefined if adding a new exercise to a workout
  exerciseId: string; // id of initially selected exercise, undefined if choosing a new one
  // optional slot to pre-filter the list by when there is NO plan subslot to derive it
  // from (e.g. the workout scanner resolving a scanned row: the slot of the AI-matched /
  // suggested exercise). Ignored when subSlotId resolves to a plan subslot — that wins.
  initialSlotId?: string;
  returnCallback: string; // REQUIRED: method name to be called on parent when exercise is switched
  showTempSwapPrompt?: boolean; // if true, show "This Session Only" vs "Permanently" prompt before returning
  // if true, ask before a permanent pick of an exercise another workout already holds, because
  // the plan edit reuses that workout's subslot and the two then share one progression (#4004).
  // The workout plan scanner leaves it off: it edits a draft and shows its own "already in plan" note.
  warnBeforeLinkingWorkouts?: boolean;
  // Complex objects stored in sessionStorage, not URL
  local?: {
    // IMPORTANT: Plan and state are passed in to operate on temporary, not yet saved, plans!
    fitnessPlan: FitnessPlan;
    fitnessState: FitnessState;
    returnContext?: unknown; // optional context data for the callback
  };
};

export interface ExerciseSwitchTempResult {
  exerciseId: string;
  isTemporary: boolean;
}

export type ExerciseSwitchPageResult = string | ExerciseSwitchTempResult;

export const IExerciseSwitchPage: PageRef<ExerciseSwitchPageParams, ExerciseSwitchPageResult> = {
  pageName: 'ExerciseSwitchPage',
} as PageRef<ExerciseSwitchPageParams, ExerciseSwitchPageResult>;
